import { combineReducers } from 'redux';

import carData from './carData/reducer';
import checkoutContent from './checkoutContent/reducer';
import appointment from './appointment/reducer';
import shoppingCart from '../../components/shoppingCart/reducer';
import servicesData from './services/reducer';
import clientRegistration from './clientRegistration/reducer';
import workshop from './workshop/reducer';
import checkoutRoot from './reducer';

const checkoutReducer = combineReducers({
    servicesData,
    shoppingCart,
    carData,
    checkoutContent,
    workshop,
    appointment,
    clientRegistration,
    checkoutRoot,
});

export default checkoutReducer;



// WEBPACK FOOTER //
// ./src/workflow/checkout/reducers.js